// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { TabLoader, TabConfig, addTab, removeAll } from 'wdna-components/lib/tabs';

const Waste: React.LazyExoticComponent<any> = React.lazy(() => import('../components/waste/List'));

export default class Loader extends TabLoader {
  /* Override tab loader method */
  public loadTab = (tabId?: string | number): void => {
    const access: boolean = true;
    if (access) {
      window.store.dispatch(removeAll());

      const tabData: TabConfig = {
        id: String(tabId || window.getStr()),
        active: true,
        title: 'Sensors | Waste Containers',
        component: Waste,
        props: {
          report: 'SENSORS_WASTE',
          title: 'Waste Containers',
        },
      };

      window.store.dispatch(addTab(tabData));
    }
  };
}
